import React, { useState } from 'react';
import './ProfessionalPage.css';

const ProgramLifecycle = () => {
    const [activeStage, setActiveStage] = useState(0);

    const stages = [
        {
            id: 0,
            title: "Initiative",
            short: "Start",
            icon: "🚀",
            color: "#3b82f6",
            description: "Defining the 'Why' and securing approval.",
            details: {
                focus: "Strategic Alignment & ROI",
                activities: ["Problem Statement Definition", "Market Analysis", "Stakeholder Alignment", "Drafting Program Charter"],
                deliverables: ["Approved Program Charter", "Business Case (PRFAQ)"]
            }
        },
        {
            id: 1,
            title: "Planning & Design",
            short: "Plan",
            icon: "📝",
            color: "#8b5cf6",
            description: "Mapping the 'What' and 'How'.",
            details: {
                focus: "Requirements & Architecture",
                activities: ["Requirements Gathering (Functional/Non-Functional)", "Technical Specification", "Architecture Review", "Resource Planning & Roadmap"],
                deliverables: ["PRD", "Tech Spec", "Gantt/Timeline", "Risk Register"]
            }
        },
        {
            id: 2,
            title: "Agile Execution",
            short: "Build",
            icon: "🔄",
            color: "#10b981",
            type: "loop",
            description: "The Iterative Engine (Hybrid/Agile).",
            details: {
                focus: "Development & Delivery Loop",
                activities: ["Sprint Planning", "Daily Standups", "Coding & CI/CD", "Testing (Unit/Integration)", "UAT & Demo"],
                deliverables: ["Working Software Increments", "Test Reports"]
            }
        },
        {
            id: 3,
            title: "Launch",
            short: "Launch",
            icon: "🚢",
            color: "#f59e0b",
            description: "Go-Live and Value Realization.",
            details: {
                focus: "Deployment & Enablement",
                activities: ["Go/No-Go Decision", "Production Deployment", "User Documentation", "Marketing & Training"],
                deliverables: ["Live Product", "Release Notes", "User Guides"]
            }
        },
        {
            id: 4,
            title: "Post-Launch & Close",
            short: "Close",
            icon: "🏁",
            color: "#ef4444",
            description: "Optimization and Closure.",
            details: {
                focus: "Stability & Retrospective",
                activities: ["Performance Monitoring", "Incident Response", "Retrospective (Lessons Learned)", "Handover to Operations"],
                deliverables: ["Post-Mortem Report", "KPI Dashboard", "Final Closure Report"]
            }
        }
    ];

    return (
        <div className="lifecycle-wrapper">
            <h3 className="lifecycle-header">Interactive Program Lifecycle (Hybrid Agile)</h3>

            {/* Timeline Visual */}
            <div className="lifecycle-timeline">
                <div className="timeline-track"></div>
                {stages.map((stage) => (
                    <div
                        key={stage.id}
                        className={`timeline-node ${activeStage === stage.id ? 'active' : ''} ${stage.type === 'loop' ? 'loop-node' : ''}`}
                        onClick={() => setActiveStage(stage.id)}
                    >
                        <div className="node-icon" style={{ borderColor: activeStage === stage.id ? stage.color : '#475569' }}>
                            {stage.icon}
                        </div>
                        <span className="node-label">{stage.short}</span>
                    </div>
                ))}
            </div>

            {/* Active Stage Details */}
            <div className="lifecycle-details" style={{ borderTop: `4px solid ${stages[activeStage].color}` }}>
                <div className="details-header">
                    <h4>{stages[activeStage].icon} {stages[activeStage].title}</h4>
                    <span className="phase-badge">{stages[activeStage].type === 'loop' ? 'Iterative Phase' : 'Linear Phase'}</span>
                </div>

                <p className="details-desc">{stages[activeStage].description}</p>

                <div className="details-grid">
                    <div className="details-col">
                        <h5>🔑 Key Activities</h5>
                        <ul>
                            {stages[activeStage].details.activities.map((act, i) => (
                                <li key={i}>{act}</li>
                            ))}
                        </ul>
                    </div>
                    <div className="details-col">
                        <h5>📦 Deliverables</h5>
                        <ul>
                            {stages[activeStage].details.deliverables.map((del, i) => (
                                <li key={i}>{del}</li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProgramLifecycle;
